import { useContext, useMemo } from 'react';
import { OrganisationContext } from '../../context';
import { OrganisationTagType } from '../../services';
import { isAdminLayout } from '../utils';

export const useTags = () => {
  const { tags: organisationTags } = useContext(OrganisationContext).organisation;

  const hasInternalTags = useMemo(
    () =>
      Boolean(
        isAdminLayout() &&
          organisationTags.filter(({ type }) => type === OrganisationTagType.INTERNAL).length
      ),
    [organisationTags]
  );

  const hasExternalTags = useMemo(
    () =>
      Boolean(organisationTags.filter(({ type }) => type === OrganisationTagType.EXTERNAL).length),
    [organisationTags]
  );

  const hasExternalStatusTags = useMemo(
    () =>
      Boolean(
        isAdminLayout() &&
          organisationTags.filter(({ type }) => type === OrganisationTagType.EXTERNAL_STATUS).length
      ),
    [organisationTags]
  );

  const hasEventTags = useMemo(
    () => Boolean(organisationTags.filter(({ type }) => type === OrganisationTagType.EVENT).length),
    [organisationTags]
  );

  const hasUserTags = useMemo(
    () => Boolean(organisationTags.filter(({ type }) => type === OrganisationTagType.USER).length),
    [organisationTags]
  );

  const hasContentTags = useMemo(
    () => hasInternalTags || hasExternalTags || hasExternalStatusTags,
    [hasExternalTags, hasInternalTags, hasExternalStatusTags]
  );

  return {
    hasInternalTags,
    hasExternalTags,
    hasExternalStatusTags,
    hasEventTags,
    hasUserTags,
    hasContentTags,
  };
};
